import { PaginatedData } from "../../../models/server-response.model"
import { EDIT_METADATA, GET_METADATA_LIST } from "../../actions"

interface InitialState {
  metaData: PaginatedData
}

const initialState: InitialState = {
  metaData: {
    data: [],
    page: 0,
    total: 15,
    total_pages: 0,
  },
}

export const metaDataReducer = (state = initialState, action: any) => {
  const { type, payload } = action
  switch (type) {
    case GET_METADATA_LIST:
      return {
        ...state,
        metaData: payload,
      }
    case EDIT_METADATA:
      return {
        ...state,
        edit_metadata: payload,
      }
    default:
      return state
  }
}
